const Entities = require('html-entities').AllHtmlEntities;

export const isClient = typeof window !== 'undefined';
export const decodeEntities = content => Entities.decode(content);

// export const getSeededRandom = seedStr => seedRandom(seedStr)();
export const getNumberedAffix = index => `${(index < 9) ? `0${index + 1}` : index + 1}`;
export const toKebabCase = str => str.replace(/\s+/g, '-').toLowerCase();
export const getSectionId = (index, key) => `${getNumberedAffix(index)}-${toKebabCase(key)}`;

export const getPrice = price => (price ? `$${parseFloat(price).toFixed(2)}` : '$0.00');

export const getPriceRange = (variants) => {
  const variantPrices = variants.map(variant => variant.price);
  const min = Math.min(...variantPrices);
  const max = Math.max(...variantPrices);
  return min === max ? `$${min.toFixed(2)}` : `$${min.toFixed(2)} - $${max.toFixed(2)}`;
};

export const getExcerpt = (content, length) => {
  if (!content || content === '') return '...';
  // Trim content to length
  const trimmedContent = content.substring(0, length);
  // Make sure excerpt doesn't split a word in half
  const excerpt = trimmedContent.substring(0, trimmedContent.lastIndexOf(' '));
  // Return with added ellipsis
  return `${excerpt}...`;
};

export const convertColorToTheme = (colourStr) => {
  const colour = toKebabCase(colourStr.toLowerCase());
  if (colour === 'pink') return 'primary';
  if (colour === 'blue') return 'secondary';
  if (colour === 'green') return 'tertiary';
  if (colour === 'purple') return 'quaternary';
  if (colour === 'white') return 'white';
  if (colour === 'off-white') return 'off-white';
  return null;
};

export const convertColorToHex = (colourStr) => {
  const colour = toKebabCase(colourStr.toLowerCase());
  if (colour === 'pink') return '#FFD0FE';
  if (colour === 'blue') return '#DAE8FF';
  if (colour === 'green') return '#EBFFD2';
  if (colour === 'purple') return '#D6D8FF';
  if (colour === 'white') return '#FFFFFF';
  if (colour === 'off-white') return '#FFFFF4';
  return null;
};

export const convertShapeColorToHex = (colourStr) => {
  const colour = toKebabCase(colourStr.toLowerCase());
  if (colour === 'lemon-fizz') return '#EEE80C';
  if (colour === 'fuchsia') return '#FF6AB8';
  if (colour === 'sky-blue') return '#02BBDC';
  if (colour === 'sea-blue') return '#3582DB';
  if (colour === 'green-apple') return '#67CB29';
  if (colour === 'peppermint') return '#00B778';
  if (colour === 'gumtree') return '#02701F';
  if (colour === 'orange') return '#FF7636';
  if (colour === 'pumpkin') return '#E99200';
  return null;
};

export const arraysEqual = (arr1, arr2) => {
  if (arr1.length !== arr2.length) return false;
  for (let i = arr1.length; i--;) { // eslint-disable-line
    if (arr1[i] !== arr2[i]) return false;
  }
  return true;
};

export const getSectionAffix = index => `${(index < 9) ? `0${index + 1}` : index + 1}`;

export const copyToClipboard = (stringToCopy) => {
  const el = document.createElement(`textarea`);
  el.value = stringToCopy;
  el.setAttribute(`readonly`, ``);
  el.style.position = `absolute`;
  el.style.left = `-9999px`;
  document.body.appendChild(el);
  el.select();
  document.execCommand(`copy`);
  document.body.removeChild(el);
};

export const scrollToPageElement = (event, elementId) => {
  if (event) event.preventDefault();
  const targetEl = document.getElementById(elementId);
  if (targetEl) targetEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
};
